import { InputRule } from 'prosemirror-inputrules';
import { MarkType } from 'prosemirror-model';

export function markdownStrongRule(markType: MarkType) {
  return new InputRule(/\*\*(.+)\*\*$/g, (state, match, start, end) => {
    return state.tr
      .insertText(match[1] + ' ', start, end)
      .addMark(start, start + match[1].length, markType.create());
  });
}
